<template>

  <div class="boolean-field-group">

    <div class="boolean-field">
      <sc-field :label="this.fieldSchema.title ? this.fieldSchema.title : this.fieldSchema.name">
      </sc-field>
    </div>

    <div class="boolean-switch">
      <sc-switch :value="this.inputValue" @input="handleSwitchChange">
      </sc-switch>
    </div>

  </div>

</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScField,
  ScSwitch,
} from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-modal-edit-boolean-field",

  data() {
    return {
      inputValue: undefined
    }
  },

  computed: {
    ...mapState(["appConfigUpdated", "appConfig"]),
  },

  props: {
    fieldSchema: {
      type: Object
    }
  },

  methods: {

    ...mapActions([
      "updateAppConfig",
    ]),

    getAppConfig(){
      return this.appConfigUpdated == null
        ? JSON.parse(this.appConfig.app_config)
        : JSON.parse (JSON.stringify(this.appConfigUpdated))
    },

    handleSwitchChange(){
      this.inputValue = !this.inputValue

      this.updateInAppConfig();
    },

    updateInAppConfig() {
      const appConfig = this.appConfigUpdated == null ? {} : { ...this.appConfigUpdated };
      appConfig[this.fieldSchema.name] = this.inputValue;
      this.updateAppConfig(appConfig);
    },

  },

  mounted() {
    let savedValue = this.appConfigUpdated[this.fieldSchema.name]
    this.inputValue = savedValue;

    if (this.inputValue === undefined){
      if (this.fieldSchema.default !== undefined){
         this.inputValue = this.fieldSchema.default
      }else{
         this.inputValue = false
      }
    }

    if (this.inputValue !== savedValue) {
      this.updateInAppConfig();
    }
  },

  components: {
    ScField,
    ScSwitch,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.boolean-field-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.0em;

  .boolean-field{
    width: 90%;
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/components/BooleanField.vue